/* ----------------------------------------------------------------------------
 * Single source of truth for app URLs. Build links with these helpers instead
 * of writing path strings by hand.
 *
 *   /job-portal                                         Job openings
 *   /job-portal/jobs/:jobId                             Job details
 *   /job-portal/jobs/:jobId/apply                       Apply
 *   /job-portal/applications                            My applications
 *   /job-portal/applications/:applicationId/assessment  Assessment
 *   /job-portal/applications/:applicationId/interview   AI interview
 *   /job-portal/offers                                  Offer letters
 * -------------------------------------------------------------------------- */

const JOB_PORTAL_ROOT = '/job-portal';

export const PATHS = {
  home: '/',
  contact: '/contact',
  privacyPolicy: '/privacy-policy',
  refundPolicy: '/refund-policy',

  jobPortal: {
    root: JOB_PORTAL_ROOT,
    job: (jobId: string) => `${JOB_PORTAL_ROOT}/jobs/${jobId}`,
    apply: (jobId: string) => `${JOB_PORTAL_ROOT}/jobs/${jobId}/apply`,
    applications: `${JOB_PORTAL_ROOT}/applications`,
    assessment: (applicationId: string) =>
      `${JOB_PORTAL_ROOT}/applications/${applicationId}/assessment`,
    interview: (applicationId: string) =>
      `${JOB_PORTAL_ROOT}/applications/${applicationId}/interview`,
    offers: `${JOB_PORTAL_ROOT}/offers`,
  },
} as const;

/** Router patterns matching the helpers above. */
export const ROUTE_PATTERNS = {
  jobPortal: {
    root: PATHS.jobPortal.root,
    job: PATHS.jobPortal.job(':jobId'),
    apply: PATHS.jobPortal.apply(':jobId'),
    applications: PATHS.jobPortal.applications,
    assessment: PATHS.jobPortal.assessment(':applicationId'),
    interview: PATHS.jobPortal.interview(':applicationId'),
    offers: PATHS.jobPortal.offers,
  },
} as const;
